import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "lobby-container" }
const _hoisted_2 = { class: "lobby-content" }
const _hoisted_3 = { class: "name-entry-block" }
const _hoisted_4 = { class: "player-feedback" }
const _hoisted_5 = {
  key: 0,
  class: "error-message short"
}
const _hoisted_6 = {
  key: 1,
  class: "char-counter"
}
const _hoisted_7 = { class: "main-lobby-block" }
const _hoisted_8 = ["onKeydown"]
const _hoisted_9 = ["disabled"]

import { ref, computed, watch, onMounted } from 'vue';
import { useUserStore } from '@/stores/userStore';
import { useGameStore } from '@/stores/gameStore';
import { useRoute } from 'vue-router';
import ErrorDisplay from './ui/ErrorDisplay.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LobbyView',
  setup(__props) {

const route = useRoute();
const userStore = useUserStore();
const gameStore = useGameStore();

const localPlayerName = ref(userStore.playerName);
const joinRoomId = ref('');

onMounted(() => {
  if (route.query.room) {
    joinRoomId.value = (route.query.room as string).toUpperCase();
  }
});

watch(localPlayerName, (newValue) => {
  if (newValue.length <= 20) {
    userStore.setPlayerName(newValue);
  }
});

const isNameTooLong = computed(() => localPlayerName.value.length > 20);
const isNameTooShort = computed(() => localPlayerName.value.length < 3);

const joinGame = () => {
  if (joinRoomId.value) {
    gameStore.joinRoom(joinRoomId.value.toUpperCase());
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Mafia Game Logo",
        class: "logo"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "form-label" }, "Представьтесь, пожалуйста", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localPlayerName).value = $event)),
          class: "form-input",
          placeholder: "Ваш никнейм"
        }, null, 512), [
          [_vModelText, localPlayerName.value]
        ]),
        _createElementVNode("div", _hoisted_4, [
          (isNameTooLong.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Не более 20 символов. "))
            : _createCommentVNode("", true),
          (isNameTooShort.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Не менее 3 символов. "))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(["char-counter", { 'error': isNameTooLong.value }])
          }, _toDisplayString(localPlayerName.value.length) + " / 20 ", 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(gameStore).createRoom()))
        }, " Создать комнату "),
        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "form-label" }, "Присоединиться к комнате по коду", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((joinRoomId).value = $event)),
          class: "form-input room-code-input",
          placeholder: "КОД",
          maxlength: "4",
          onKeydown: _withKeys(_withModifiers(joinGame, ["prevent"]), ["enter"])
        }, null, 40, _hoisted_8), [
          [_vModelText, joinRoomId.value]
        ]),
        _createElementVNode("button", {
          class: "btn",
          onClick: joinGame,
          disabled: joinRoomId.value.length < 4
        }, " Присоединиться ", 8, _hoisted_9),
        _createVNode(ErrorDisplay, {
          message: _unref(gameStore).error,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_unref(gameStore).clearError()))
        }, null, 8, ["message"])
      ])
    ])
  ]))
}
}

})